<template>
  <div v-if="relatedList.length > 0" class="related mt48">
    <h2 class="title c5a ab">関連記事</h2>
    <div class="post_list mt48">
      <post v-for="(val, index) in relatedList"
        :title="val.title"
        :thumbnail="val.thumbnailImagePath"
        :hashtag="val.tagList"
        :date="val.publicationDate"
        :is_new="val.new"
        :is_ranking="0"
        :id="val.articleId"
        :key="index"
      />
    </div>
  </div>
</template>

<script>
import Post from '@/components/fanClub/column/Post';
import TagList from '@/components/api/fanClub/article';

export default {
  components: {
    Post,
  },
  data() {
    return {
      relatedList: [],
    }
  },
  methods: {
    addRelatedList(val) {
      this.relatedList.push(...val);
    },
    async apiGetRelatedArticleList() {
      let data = {
        articleId: this.$route.params.articleId
      }
      await TagList.getRelatedArticleList(data).then((val) => {
        console.log('関連記事');
        console.log(val);
        this.relatedList.splice(0, val.length);
        this.addRelatedList(val);
      });
    }
  },
  created() {
    this.apiGetRelatedArticleList();
  },
  watch: {
    $route(to, from) {
      if(to.params.articleId != from.params.articleId) {
        this.apiGetRelatedArticleList();
      }
    }
  }
}
</script>

<style lang="css" scoped>
.title {
  text-align: center;
}
.post_list {
  margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/fanClub/column/RelatedList.vue